<template>
  <sc-render :fields="fields" :emptyMessage="$t('NO_DATA_SOURCE_EXIST')">
    <sh-header />
  </sc-render>
</template>

<script>
import ShHeader from '~/components/sh-header'
import ScRender from '~/components/sitecore/sc-render'

export default {
  name: 'ScHeader',
  components: {
    ScRender,
    ShHeader
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    },
    rendering: {
      type: Object
    }
  }
}
</script>
